import headerLogo from '../shared_assets/everplans-transparent-white-logo.svg'

const Logo = () => <img alt='Everplans logo' className='everplans-logo' src={headerLogo} />

export default Logo
